import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { fetchUserData } from 'modules/User/redux/fetchUserData';
import RoomsView from 'modules/User/views/RoomsView';
import auth, { STORAGE_ROOMS_TOKEN } from 'base/auth';

const FAKE_TOKEN = '$2a$08$Zt1W9CheTpsAZxoVw7dfs.HFg4Tcs55RTcvG4mZ8IMqj0lnjCsX3O';

class RoomsAuthorization extends Component {
  componentWillMount = () => {
    const { dispatch, location } = this.props;
    const tokenParam = new URLSearchParams(location.search).get('token');
    const token = tokenParam ? tokenParam : auth.getToken(STORAGE_ROOMS_TOKEN);

    // console.log('token', token)
    if (token) {
      auth.setToken(token, false, STORAGE_ROOMS_TOKEN);

      dispatch(fetchUserData(token));
    }
  }

  render() {
    const { location, user } = this.props;
    const token = auth.getToken(STORAGE_ROOMS_TOKEN);

    if (token && user.isLoading) {
      return (
        <div className="rooms-wrapper">
          <h1 className="rooms-title">Sprawdzanie danych...</h1>
        </div>
      )
    }

    if (user.error) {
      return (
        <div className="rooms-wrapper">
          <h1 className="rooms-title">Niepoprawne dane.</h1>
          <p className="rooms-subtitle">Aby móc wybrać pokój wejdź na strone przez link z e-maila.</p>
        </div>
      )
    }

    if (user.data) {
      return (
        <React.Fragment>
          <RoomsView user={user.data}  token={new URLSearchParams(this.props.location.search).get('token')} />
          <ToastContainer />
        </React.Fragment>
      )
    }

    return (
      <div className="rooms-wrapper">
        <h1 className="rooms-title">Nie jesteś zalogowany!</h1>
        <p className="rooms-subtitle">Aby móc wybrać pokój wejdź na strone przez link z e-maila.</p>
      </div>
    )
  }
};

export default connect(
  state => ({
    user: state.user
  })
)(RoomsAuthorization);



// WEBPACK FOOTER //
// ./src/modules/User/views/RoomsAuthorization.js